
export enum EmailComposerModeEnum {
    COMPOSE = 'COMPOSE',
    CONVERSATION = 'CONVERSATION'
}
